let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZaRU")).then(() => parcelRequire('cmt3m'));